import { render, staticRenderFns } from "./EntregaDestinoTable.vue?vue&type=template&id=c3b39264"
import script from "./EntregaDestinoTable.vue?vue&type=script&lang=js"
export * from "./EntregaDestinoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports